// ── idv_service section (mockup) ────────────────────────────────────────────
//
// The IDV orchestrator: which vendor connector routes IDV, Hosted OneSDK
// settings, and the list of IDV flows (each with a Flow ID + label + mapped
// workflow). Local state only — not saved to the workflow JSON.
import { useState } from 'react'
import { Plus, Trash2 } from 'lucide-react'
import { Field, SelectInput, TextInput, Toggle } from './fields'
import { ConfigSection } from './ConfigSection'

interface FlowRow {
  id: string
  label: string
  workflow: string
}

const CONNECTORS = ['con_daon', 'con_incode', 'con_onfido']

export function IdvServiceSection() {
  const [connector, setConnector] = useState(CONNECTORS[0])
  const [hosted, setHosted] = useState(true)
  const [domain, setDomain] = useState('')
  const [flows, setFlows] = useState<FlowRow[]>([{ id: 'idv', label: 'Biometrics/OCR', workflow: '' }])

  const setFlow = (i: number, p: Partial<FlowRow>) => setFlows((f) => f.map((x, j) => (j === i ? { ...x, ...p } : x)))
  const addFlow = () => setFlows((f) => [...f, { id: '', label: '', workflow: '' }])
  const removeFlow = (i: number) => setFlows((f) => f.filter((_, j) => j !== i))

  return (
    <ConfigSection title="IDV service" file="idv_service" defaultOpen>
      <Field label="IDV provider connector">
        <SelectInput value={connector} onChange={(e) => setConnector(e.target.value)}>
          {CONNECTORS.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </SelectInput>
      </Field>

      <Toggle label="Use Hosted OneSDK" checked={hosted} onChange={setHosted} />

      <Field label="Verification domain">
        <TextInput value={domain} onChange={(e) => setDomain(e.target.value)} placeholder="https://verify.uat.frankie.one/v2/" />
      </Field>

      <div>
        <div className="flex items-center justify-between mb-1.5">
          <p className="text-[10px] uppercase tracking-wide text-[#5b6b85]">IDV Flows</p>
          <button
            type="button"
            onClick={addFlow}
            className="text-[10px] flex items-center gap-1 text-[#818cf8] hover:text-[#a5b4fc]"
          >
            <Plus size={11} />
            Add flow
          </button>
        </div>
        <div className="flex flex-col gap-2">
          {flows.map((f, i) => (
            <div key={i} className="flex flex-col gap-1.5 border border-[#1e2c44] rounded p-2">
              <div className="flex items-center gap-1.5">
                <TextInput value={f.id} onChange={(e) => setFlow(i, { id: e.target.value })} placeholder="Flow ID (e.g. idv_daon)" />
                <button
                  type="button"
                  onClick={() => removeFlow(i)}
                  className="p-1 text-[#5b6b85] hover:text-[#fb7185] shrink-0"
                  title="Remove flow"
                >
                  <Trash2 size={13} />
                </button>
              </div>
              <TextInput value={f.label} onChange={(e) => setFlow(i, { label: e.target.value })} placeholder="Label (e.g. Biometrics/OCR)" />
              <TextInput
                value={f.workflow}
                onChange={(e) => setFlow(i, { workflow: e.target.value })}
                placeholder="Mapped workflow (e.g. AUS-Basic3V-TwoPlus)"
              />
            </div>
          ))}
        </div>
      </div>
    </ConfigSection>
  )
}
